module.exports = __webpack_public_path__ + "img/red-triangle-pointed-up.26528d74.png";